/*
 * ListFilters Messages
 *
 * This contains all the text for the ListFilters component.
 */
import { defineMessages } from 'react-intl'

export default defineMessages({
  levelOne: {
    id: 'app.components.ListFilters.levelOne',
    defaultMessage: 'Competitive level',
  },
  levelTwo: {
    id: 'app.components.ListFilters.levelTwo',
    defaultMessage: 'Age',
  },
  levelThree: {
    id: 'app.components.ListFilters.levelThree',
    defaultMessage: 'Gender',
  },
  competitionSelectInfo: {
    id: 'app.components.ListFilters.competitionSelectInfo',
    defaultMessage: 'Please Select Competition First.',
  },
  venues: {
    id: 'app.components.ListFilters.venues',
    defaultMessage: 'Venues',
  },
  selected: {
    id: 'app.components.ListFilters.selected',
    defaultMessage: 'Selected',
  },
  select: {
    id: 'app.components.ListFilters.select',
    defaultMessage: 'Select',
  },
  members: {
    id: 'app.components.ListFilters.members',
    defaultMessage: 'Members',
  },
  playingSurface: {
    id: 'app.components.ListFilters.playingSurface',
    defaultMessage: 'Playing Surfaces',
  },
  playingSurfaceSelected: {
    id: 'app.components.ListFilters.playingSurfaceSelected',
    defaultMessage: 'Playing Surfaces Selected',
  },
})
